// extracted by mini-css-extract-plugin
export default {"container":"GalleryAmigurumis_container__PTCsp","gallery":"GalleryAmigurumis_gallery__L+CvL","item":"GalleryAmigurumis_item__qiD4h","image":"GalleryAmigurumis_image__Llv0h"};